import { Appointment } from '../dossier';
import { FitterGoogleData } from '../google-api';
import { GeoCoordinates } from '../location';
import { FilterLabels } from './filter-labels';
import { FitterContact } from './fitter-contact';
import { FitterManager } from './fitter-manager';
import {
  FitterOpeningHours,
  FitterSpecificHours,
} from './fitter-opening-hours';
import { FitterResource } from './fitter-resource';
import { FitterServiceType } from './fitter-service-type';
import { FitterType } from './fitter-type';
import { FitterVehicle } from './fitter-vehicle';

export interface Fitter {
  _id: string;
  id: string;
  fceId: string;
  internalId?: string;
  insurerId: string;
  siret: string;
  brandId: string;
  brand?: string;
  fitterType: FitterType;
  city: string;
  address: string;
  cp: string;
  phone: string;
  email?: string;
  location: GeoCoordinates;
  google?: FitterGoogleData;
  repairRatio?: { [insurerId: string]: number };
  distance?: number;
  duration?: number;
  brandOrder?: number;
  globalScore?: number;
  appointmentScore?: number;
  appointments?: Appointment[];
  timezone?: string;
  vehicles?: FitterVehicle[];
  contactList?: FitterContact[];
  resources?: FitterResource[];
  interventionVehicles?: FitterResource[];
  managers?: FitterManager[];
  serviceTypes?: FitterServiceType[];
  openingHours?: FitterOpeningHours;
  specificHours?: FitterSpecificHours;
  maxParallelJob?: number;
  maxMobilityParallelJob?: number;
  useTechAvailabilityForOutisdeIntervention?: boolean;
  filterLabels?: FilterLabels;
  mobilityZones?: string[];
}

export interface FitterDbFormat extends Omit<Fitter, '_id' | 'insurerId'> {
  codeFce: { [insurerId: string]: string };
}

export type FitterLightFormat = Omit<
  Fitter | FitterDbFormat,
  | 'managers'
  | 'vehicles'
  | 'interventionVehicles'
  | 'serviceTypes'
  | 'filterLabels'
  | 'maxMobilityParallelJob'
  | 'maxParallelJob'
  | 'useTechAvailabilityForOutisdeIntervention'
>;
